import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M213.333 451.765V282.353C213.333 251.181 235.608 225.882 266.667 225.882H445.488V282.353C445.488 313.525 470.787 338.823 501.959 338.823C533.131 338.823 558.43 313.525 558.43 282.353V225.882H1349.02V282.353C1349.02 313.525 1374.32 338.823 1405.49 338.823C1436.66 338.823 1461.96 313.525 1461.96 282.353V225.882H1653.33C1684.39 225.882 1706.67 251.181 1706.67 282.353V451.765H213.333ZM213.333 1813.34L1706.67 1819.59V570.973H213.333V1813.34ZM1653.33 112.941H1461.96V56.4706C1461.96 25.2988 1436.66 0 1405.49 0C1374.32 0 1349.02 25.2988 1349.02 56.4706V112.941H558.431V56.4706C558.431 25.2988 533.133 0 501.961 0C470.789 0 445.49 25.2988 445.49 56.4706V112.941H276.078C182.676 112.941 106.667 188.951 106.667 282.353V451.765V564.706V1920H1813.33V266.667C1813.33 173.264 1746.74 112.941 1653.33 112.941Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1019.51 1123.69L960.002 931.876L900.459 1123.69H695.527L861.346 1249.82L800.38 1446.25L959.995 1324.85L1119.62 1446.29L1058.63 1249.81L1224.48 1123.69H1019.51ZM1308.54 1093.85L1348.21 1081.35L1348.14 1081.26L1308.47 1093.63M1348.26 1081.22L1348.33 1081.31L1384.84 1069.8C1389.76 1085.41 1384.49 1102.44 1371.79 1112.16L1151.64 1279.59L1235.71 1550.44C1240.58 1566.15 1235.26 1583.18 1222.51 1592.79C1209.81 1602.41 1192.7 1602.41 1180 1592.74L959.989 1425.37L739.931 1592.74C733.557 1597.58 726.128 1599.99 718.699 1599.99C711.27 1599.99 703.841 1597.58 697.516 1592.79C684.766 1583.18 679.396 1566.15 684.265 1550.49L768.342 1279.59L548.234 1112.16C535.485 1102.44 530.264 1085.41 535.133 1069.8C540.002 1054.2 553.806 1043.69 569.517 1043.69H841.527L925.605 772.837C925.61 772.82 925.6 772.855 925.605 772.837C930.489 757.206 944.346 746.667 959.989 746.667C975.7 746.667 989.504 757.177 994.423 772.785L1001.89 796.918L1078.45 1043.69H1350.46C1366.17 1043.69 1379.98 1054.2 1384.84 1069.8L1348.26 1081.22Z"
}));

var IconImportantDatesLine = /*#__PURE__*/function (_Component) {
  _inherits(IconImportantDatesLine, _Component);

  var _super = _createSuper(IconImportantDatesLine);

  function IconImportantDatesLine() {
    _classCallCheck(this, IconImportantDatesLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconImportantDatesLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconImportantDates",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconImportantDatesLine.displayName = "IconImportantDatesLine";
  return IconImportantDatesLine;
}(Component);

IconImportantDatesLine.glyphName = 'important-dates';
IconImportantDatesLine.variant = 'Line';
IconImportantDatesLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconImportantDatesLine;
export { IconImportantDatesLine };